import React from "react";
import { ResourceEnum } from "src/constants/constants.ts";
import type { ModuleOptions } from "src/system/module.types.ts";
import type { OwnerResource } from "@exonn/js-sdk";
import type { RouteObject } from "react-router-dom";

const accountingRoute: RouteObject = {
  lazy: () =>
    import(
      "src/admin/modules/owner/forms/owner/tabs/accounting/accounting.route.tsx"
    ),
};

export const module: ModuleOptions<OwnerResource> = {
  resource: ResourceEnum.Owner,
  bigIcon: <span className={"icon-20-customers_lst"} />,
  smallIcon: <span className={"icon-15-customers_lst"} />,

  tabs: {
    edit: {
      getTitle: (resource) => resource.company_name,
    },
  },
  /**
   * "Buchhaltung" holds the owner's chart of accounts (S2a); tax settings follow
   * in S3. Hidden while the owner does not exist yet: a chart binds to an owner id.
   */
  formTabs: {
    general: {
      title: (t) => t("formTabs.general.title"),
    },
    accounting: {
      title: (t) => t("formTabs.accounting.title"),
      routeObject: accountingRoute,
      isHidden: ({ data }) => data === undefined,
    },
  },
};
